export default {
  Mantra(state, payload) {
    state.mantra = payload;
  },
};
